import $ from "../../libs/jquery-3.3.1.min.js";
import {gsap} from "../../libs/gsap/all.js";
import {tsParticles} from "../../libs/tsparticles.all.bundle.min.js";

// Constructor
export class Particles {

  constructor(data) {
    // Particle instances
    this.instances = {};

    // Particle shape image rotation
    const shapeRotation = {
      "transport": -25,
      "combustion": -40,
      "farming": -40,
      "heating": -55,
      "decomposition": -75,
    }

    // Init particles
    Object.keys(data.greenhouse_impact.impact).forEach((impact, index) => {
      tsParticles.load({
        id: "ges-particle-" + impact,
        options: {
          fullScreen: false,
          detectRetina: false,
          pauseOnBlur: false,
          pauseOnOutsideViewport: false,
          fpsLimit: 120,
          emitters: [
            {
              position: {
                x: 96,
                y: 80
              },
              rate: {
                quantity: 2,
                delay: 0.19
              },
              particles: {
                shape: {
                  type: "circle",
                },
                color: {
                  value: "#7ABECC"
                },
                size: {
                  value: {min: 1, max: 9},
                  animation: {
                    enable: true,
                    speed: 1.0,
                    startValue: "min",
                    destroy: "max",
                    sync: true
                  }
                },
                opacity: {
                  value: {min: 0, max: 1},
                  animation: {
                    enable: true,
                    random: false,
                    speed: 2.0,
                    sync: true,
                    count: 1,
                    startValue: "min",
                    mode: "increase"
                  }
                },
                move: {
                  enable: true,
                  speed: 2.5,
                  direction: "top-left",
                  random: false,
                  straight: false,
                  outModes: {
                    default: "destroy"
                  },
                  bounce: false
                },
                collisions: {
                  enable: false
                }
              }
            },
            {
              position: {
                x: 97,
                y: 83
              },
              rate: {
                quantity: 1,
                delay: 0.75
              },
              particles: {
                shape: {
                  type: "image",
                  options: {
                    image: [
                      {
                        src: "images/ges/particles/ch4.svg",
                        width: 35,
                        height: 20
                      },
                      {
                        src: "images/ges/particles/co2.svg",
                        width: 35,
                        height: 20
                      },
                      {
                        src: "images/ges/particles/n2o.svg",
                        width: 34,
                        height: 20
                      }
                    ]
                  }
                },
                rotate: {
                  value: shapeRotation[impact] ?? -10,
                },
                size: {
                  value: {min: 10, max: 35},
                  animation: {
                    enable: true,
                    speed: 1.0,
                    startValue: "min",
                    destroy: "max",
                    sync: true
                  }
                },
                opacity: {
                  value: {min: 0, max: 1},
                  animation: {
                    enable: true,
                    random: false,
                    speed: 2.0,
                    sync: true,
                    count: 1,
                    startValue: "min",
                    mode: "increase"
                  }
                },
                move: {
                  enable: true,
                  speed: 1.85,
                  direction: "top-left",
                  random: false,
                  straight: false,
                  outModes: {
                    default: "destroy"
                  },
                  bounce: false
                },
                collisions: {
                  enable: false
                }
              }
            }
          ]
        }
      }).then(instance => {
        instance.pause();
        this.instances[impact] = instance;
      });
    });
  }

}
